module.exports = __webpack_public_path__ + "static/media/savio35.c37395fc.jpg";